import Head from "next/head";

// ** API
import tagsApi from "@/api/tags/api";
import topicsApi from "@/api/topics/api";
import articlesApi from "@/api/articles/api";

// ** Components
import Header from "../../components/Header";
import RecentlyPublished from "../../components/RecentlyPublished";

// ** MUI
import { Container } from "@mui/material";

// ** Layout
import DefaultLayout from "../../layout/DefaultLayout";

export async function getStaticProps() {
  // Set pagination (first 3 articles)
  const page = 1;
  const pageSize = 3;

  console.log("LOG");

  // Fetch data in parallel for better performance
  const [tagsRes, topicsRes, articlesRes] = await Promise.allSettled([
    tagsApi.getTags(),
    topicsApi.getTopics(),
    articlesApi.getPaginatedArticles(page, pageSize),
  ]);

  return {
    props: {
      tags: tagsRes.status === "fulfilled" ? tagsRes.value : { data: [] },
      topics: topicsRes.status === "fulfilled" ? topicsRes.value : { data: [] },
      articles:
        articlesRes.status === "fulfilled" ? articlesRes.value : { data: [] },
    },
    revalidate: 10, // Re-generate the page every 10 seconds
  };
}

function Home({ tags, topics, articles }) {
  return (
    <>
      <Head>
        <title>Home | Valentin Marko – Software Development Blog</title>
        <meta
          name="description"
          content="Discover articles, topics, and insights on software development — React, JavaScript, TypeScript, and more."
        />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://valentinmarko.com/home" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Home | Valentin Marko – Software Development Blog"
        />
        <meta
          property="og:description"
          content="Discover articles, topics, and insights on software development — React, JavaScript, TypeScript, and more."
        />
        <meta property="og:url" content="https://valentinmarko.com/home" />
        <meta
          property="og:site_name"
          content="Valentin Marko – Software Development Blog"
        />
        <meta
          property="og:image"
          content="https://valentinmarko.com/about.webp"
        />

        <meta name="theme-color" content="#667EEA" />
      </Head>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Person",
                "@id": "https://valentinmarko.com/#person",
                name: "Valentin-Marko Cîmpan",
                url: "https://valentinmarko.com/home",
                jobTitle: "Full Stack Developer",
                sameAs: ["https://www.linkedin.com/in/marko-cimpan/"],
              },
              {
                "@type": "WebSite",
                "@id": "https://valentinmarko.com/#website",
                name: "Valentin Marko – Software Development Blog",
                url: "https://valentinmarko.com/home",
                publisher: { "@id": "https://valentinmarko.com/#person" },
                inLanguage: "en",
              },
              {
                "@type": "Blog",
                "@id": "https://valentinmarko.com/#blog",
                name: "Valentin Marko – Software Development Blog",
                url: "https://valentinmarko.com/blog",
                description:
                  "Discover articles, topics, and insights on software development — React, JavaScript, TypeScript, and more.",
                publisher: { "@id": "https://valentinmarko.com/#person" },
              },
              {
                "@type": "WebPage",
                "@id": "https://valentinmarko.com/home#webpage",
                name: "Home | Valentin Marko – Software Development Blog",
                url: "https://valentinmarko.com/home",
                description:
                  "Discover articles, topics, and insights on software development — React, JavaScript, TypeScript, and more.",
                isPartOf: { "@id": "https://valentinmarko.com/#website" },
                about: { "@id": "https://valentinmarko.com/#person" },
              },
            ],
          }),
        }}
      />

      <Container>
        <Header />
        <RecentlyPublished tags={tags} topics={topics} articles={articles} />
      </Container>
    </>
  );
}

Home.getLayout = (page) => <DefaultLayout>{page}</DefaultLayout>;

export default Home;
